module.exports = __webpack_public_path__ + "static/img/SA@2x.bc57933a.jpg";